import { FC } from 'react';
import { DealNoteService } from '../../../../services/portfolio/DealNoteService';
import { NotesCountMap, NoteView } from '../../../../types/Note';
import NoteModal from '../../../shared/modals/notes-modal/NoteModal';

type NotesModalProps = {
  dealerId: string;
  leadId: string;
  fullName: string;
  vin: string;
  notesCountMap: NotesCountMap[];
  isNotesModalOpen: boolean;
  openNotesModal: (value: boolean) => void;
  updateNotesCount: (value: NotesCountMap) => void;
  titleComponent: JSX.Element;
};

const NotesModal: FC<NotesModalProps> = (props) => {
  const getNotes = (leadId: string, dealerId: string): Promise<NoteView[]> => {
    return DealNoteService.getNotes(leadId, dealerId);
  };

  const postNotes = (
    leadId: string,
    noteInput: string,
    dealerId: string,
    vin: string,
  ): Promise<NoteView> => {
    return DealNoteService.postNotes(leadId, noteInput, dealerId, vin).then((r) => r[0]);
  };

  const updateNotesCount = (value: NotesCountMap) => {
    props.updateNotesCount(value);
  };

  const retryNotePush = (id: string | number, dealerId: string, addMissingData: boolean) => {
    return DealNoteService.retryNotePush(id, dealerId, addMissingData);
  };

  return (
    <>
      <NoteModal
        dealerId={props.dealerId}
        fullName={props.fullName}
        isNotesModalOpen={props.isNotesModalOpen}
        leadId={props.leadId}
        notesCountMap={props.notesCountMap}
        vin={props.vin}
        titleClassName='portfolio-note'
        titleIconClassName='am-icon'
        hasCustomTitle={true}
        showTitleIcon={true}
        titleComponent={props.titleComponent}
        titleIconType='notes'
        hasRetry={true}
        openNotesModal={props.openNotesModal}
        getNotes={getNotes}
        postNotes={postNotes}
        retry={retryNotePush}
        updateNotesCount={updateNotesCount}
      />
    </>
  );
};

export default NotesModal;
